import { useTranslation } from 'react-i18next';
import Layout from '@/components/feature/Layout';

export default function About() {
  const { t } = useTranslation();

  const values = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Know-how',
      description: 'Unser gesamtes Team ist sowohl planerisch als auch organisatorisch und technisch hochqualifiziert ausgebildet. Der Einsatz modernster Maschinen und CAD-Technologien garantieren Ihnen Produktionsverfahren auf höchstem Niveau.',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Individualität',
      description: 'Wir bauen genau die Maschinen, die Sie benötigen und die Ihren Erfolg garantieren. Ihre Anforderungen sind unser Anspruch. Individuelle Lösungen sind unsere Spezialität.',
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Persönliche Beratung',
      description: 'Unser Erfolg, unsere Marktposition und unser Ansehen bei unseren Kunden sind das Ergebnis von Persönlichkeit, Menschlichkeit, Einfühlungsvermögen und technischem Gespür und Geschick.',
    },
  ];

  return (
    <Layout>
      {/* Page Header */}
      <div className="bg-foreground-900 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <span className="text-accent-400 text-sm font-medium uppercase tracking-wider mb-4 block">
            {t('nav.company')}
          </span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
            {t('about.title')}
          </h1>
          <p className="text-white/60 text-base md:text-lg max-w-2xl">
            {t('about.subtitle')}
          </p>
        </div>
      </div>

      {/* About Content */}
      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20German%20industrial%20manufacturing%20company%20building%20exterior%2C%20steel%20and%20glass%20factory%20architecture%2C%20clean%20professional%20industrial%20facility%2C%20blue%20sky%2C%20professional%20architectural%20photography%2C%20warm%20daylight%2C%20high%20detail&width=800&height=600&seq=company-building-2026&orientation=landscape"
                  alt="Maschinenfabrik Bock Unternehmen"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 md:-bottom-8 md:-left-8 bg-accent-500 text-white rounded-xl p-5 md:p-6 shadow-lg">
                <div className="font-heading text-3xl md:text-4xl font-bold">1966</div>
                <div className="text-accent-100 text-sm mt-1">Jahre Tradition</div>
              </div>
            </div>
            <div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6 leading-tight">
                Maschinenfabrik Bock GmbH & Co. KG
              </h2>
              <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
                Die <b>Maschinenfabrik Bock GmbH & Co. KG</b> ist heute ein weltweit operierendes Familienunternehmen mit Vertretungen in vielen Ländern, das sich zu einem führenden Hersteller von Anspitzmaschinen mit unterschiedlichen Technologien entwickelt hat.
              </p>
              <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
                Wir produzieren <b>„umformende" und „spanende" Anspitzmaschinen, Hämmer- und Richtmaschinen</b>. In der Hauptsache sind es standardisierte Maschinen und Lösungen, die wir jeweils individuell auf Kundenwunsch zu Sonderlösungen anpassen.
              </p>
              <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
                Mit einem <b>hochqualifizierten Team</b> und dem Einsatz moderner Fertigungsmaschinen und <b>neuester CAD-Technologie</b> sichern wir uns einen permanenten Wettbewerbsvorsprung.
              </p>
              <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
                <b>Seit 1966</b> liefert die in Lüdenscheid ansässige <b>Maschinenfabrik Bock</b> Maschinen für die <b>Draht- und Rohrindustrie</b>.
              </p>
              <div className="flex items-center gap-3 px-4 py-3 bg-accent-50 rounded-lg border border-accent-200">
                <i className="ri-medal-line text-accent-500 text-xl"></i>
                <span className="text-accent-800 font-medium text-sm">100% Made in Germany</span>
              </div>
            </div>
          </div>

          {/* Values */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value) => (
              <div
                key={value.title}
                className="bg-background-100 rounded-xl p-8 border border-background-200 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-xl bg-primary-50 flex items-center justify-center mb-6">
                  <i className={`${value.icon} text-2xl text-primary-500`}></i>
                </div>
                <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-3">
                  {value.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}